(() => {
  if (window.__powlifeMotionInitialized) return;
  window.__powlifeMotionInitialized = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const EVERYDAY_MOBILE_STYLE_ID = 'PowlifeEverydayMobileDensityStyles';
  const observer = reduceMotion
    ? null
    : new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );

  const ensureEverydayMobileDensityStyles = () => {
    if (document.getElementById(EVERYDAY_MOBILE_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = EVERYDAY_MOBILE_STYLE_ID;
    style.textContent = `
      @media (max-width: 749px) {
        #MainContent .powlife-products .powlife-product-card__subtitle {
          display: block !important;
          overflow: hidden !important;
          margin-top: 3px !important;
          font-size: 8px !important;
          line-height: 1.15 !important;
          white-space: nowrap !important;
          text-overflow: ellipsis !important;
          -webkit-line-clamp: 1 !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const initializeMotion = (scope) => {
    const sections = [];

    if (scope.matches && scope.matches('[data-powlife-motion]')) sections.push(scope);
    sections.push(...scope.querySelectorAll('[data-powlife-motion]'));

    sections.forEach((section) => {
      if (section.dataset.powlifeMotionReady === 'true') return;
      section.dataset.powlifeMotionReady = 'true';
      section.classList.add('powlife-motion-ready');

      if (reduceMotion) {
        section.classList.add('is-visible');
      } else {
        requestAnimationFrame(() => observer.observe(section));
      }
    });
  };

  const liftEverydaySwipeHint = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const productsSection = document.querySelector('#MainContent .powlife-products');
    if (!productsSection) return;

    const sectionRect = productsSection.getBoundingClientRect();
    const candidates = [...document.querySelectorAll('p, div, span')];
    const hint = candidates.find((element) => {
      const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/^Swipe for more(?:\s*→)?$/i.test(text)) return false;
      if (element.children.length > 1) return false;

      const rect = element.getBoundingClientRect();
      return rect.top >= sectionRect.top && rect.top <= sectionRect.bottom + 100;
    });

    if (!hint) return;

    const arrowPattern = /^(?:→|⟶|➜|➝|›)$/;
    const hintText = (hint.textContent || '').replace(/\s+/g, ' ').trim();
    const parent = hint.parentElement;
    let arrow = null;

    if (parent) {
      arrow = [...parent.children].find((element) => {
        if (element === hint) return false;
        return arrowPattern.test((element.textContent || '').replace(/\s+/g, ' ').trim());
      }) || null;

      if (!arrow) {
        arrow = [...parent.querySelectorAll('span, div, p')].find((element) => {
          if (element === hint || hint.contains(element)) return false;
          return arrowPattern.test((element.textContent || '').replace(/\s+/g, ' ').trim());
        }) || null;
      }
    }

    if (arrow && parent && parent.children.length <= 4) {
      parent.style.setProperty('display', 'flex', 'important');
      parent.style.setProperty('align-items', 'center', 'important');
      parent.style.setProperty('justify-content', 'center', 'important');
      parent.style.setProperty('gap', '12px', 'important');
      parent.style.setProperty('transform', 'translateY(-10px)', 'important');
      parent.style.setProperty('margin-top', '0', 'important');
      parent.style.setProperty('margin-bottom', '0', 'important');

      hint.style.setProperty('transform', 'none', 'important');
      hint.style.setProperty('margin', '0', 'important');
      hint.style.setProperty('display', 'inline-flex', 'important');
      hint.style.setProperty('align-items', 'center', 'important');
      hint.style.setProperty('white-space', 'nowrap', 'important');

      arrow.style.setProperty('position', 'static', 'important');
      arrow.style.setProperty('inset', 'auto', 'important');
      arrow.style.setProperty('transform', 'none', 'important');
      arrow.style.setProperty('margin', '0', 'important');
      arrow.style.setProperty('display', 'inline-flex', 'important');
      arrow.style.setProperty('align-items', 'center', 'important');
      arrow.style.setProperty('line-height', '1', 'important');
      return;
    }

    hint.style.setProperty('display', 'inline-flex', 'important');
    hint.style.setProperty('align-items', 'center', 'important');
    hint.style.setProperty('gap', '10px', 'important');
    hint.style.setProperty('transform', 'translateY(-10px)', 'important');
    hint.style.setProperty('margin-top', '0', 'important');
    hint.style.setProperty('margin-bottom', '0', 'important');

    if (/→/.test(hintText)) hint.style.setProperty('white-space', 'nowrap', 'important');
  };

  const initializePage = (scope) => {
    ensureEverydayMobileDensityStyles();
    initializeMotion(scope);
    requestAnimationFrame(liftEverydaySwipeHint);
    window.setTimeout(liftEverydaySwipeHint, 180);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializePage(document), { once: true });
  } else {
    initializePage(document);
  }

  document.addEventListener('shopify:section:load', (event) => initializePage(event.target));

  const swipeHintObserver = new MutationObserver(() => liftEverydaySwipeHint());
  swipeHintObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
